import Vue from "vue";
import Component from "vue-class-component";
import * as ExchangeUtils from "@/utils/exchangeUtils";

@Component
export default class ExchangeMixin extends Vue {
  /**
   * 🖼 Returns a local path to the exchange image
   */
  public getExchangeImageUrl(exchangeName: string) {
    let imageUrl;
    try {
      imageUrl = require("@/assets/logos/exchanges/" +
        exchangeName
          .toLowerCase()
          .split(".")
          .join("") +
        "-logo.svg");
    } catch (error) {
      imageUrl = require("@/assets/logos/exchanges/" +
        exchangeName
          .toLowerCase()
          .split(".")
          .join("") +
        "-logo.png");
    }
    return imageUrl;
  }

  /**
   * 🎁 Mixin wrapper of the encoding of an exchange name
   */
  public encodeExchangeName = (exchangeName: string) =>
    ExchangeUtils.encodeExchangeName(exchangeName);

  /**
   * 🎁 Mixin wrapper of the decoding of an exchange name
   */
  public decodeExchangeName = (exchangeName: string) =>
    ExchangeUtils.decodeExchangeName(exchangeName);

  public isSubaccountSupported = (exchangeName: string) =>
    ExchangeUtils.EXCHANGES_SUBACCOUNT_SUPPORT[exchangeName];

  // 📦 The fields that should be displayed based on the selected exchange
  public get fieldsAvailableForExchange(): (exchange: string) => any {
    return (exchange: string) => {
      const baseAPIFields = ExchangeUtils.EXCHANGES_CONNECTION_FIELDS[exchange]
      if (this.isSubaccountSupported(exchange)) {
        baseAPIFields["subaccountName"] = true;
      }
      return baseAPIFields;
    };
  }

  // 🔎 Validates the exchange fields
  public get areFieldsValid(): (
    exchange: string | null,
    fieldValues: any
  ) => boolean {
    return (exchange: string | null, fieldValues: any) => {
      if (!exchange) {
        return false;
      }

      const fields: any = this.fieldsAvailableForExchange(exchange);
      const fieldsToValidate: any = [];

      // Get all keys that need to be validated
      Object.keys(fields).forEach((key: string) => {
        switch (key) {
          case "apiKey":
            fieldsToValidate.push(fieldValues.apiKey);
            break;
          case "apiSecret":
            fieldsToValidate.push(fieldValues.apiSecret);
            break;
          case "apiPassPhrase":
            fieldsToValidate.push(fieldValues.apiPassPhrase);
            break;
          case "accessToken":
            fieldsToValidate.push(fieldValues.apiAccessToken);
            break;
        }
      });

      let isValid = true;

      // Check if each field is valid
      fieldsToValidate.forEach((field: string) => {
        if (
          field === undefined ||
          field === null ||
          (field as string).length <= 0
        ) {
          isValid = false;
        }
      });

      return isValid;
    };
  }

  // 🏗 Formats the available proxy IPs for a certain exchange so they can be copied
  public get formatWhitelistedIPsForExchange(): (exchange: string) => any {
    return (exchange: string) =>
      ExchangeUtils.formatWhitelistedIPsForExchange(exchange);
  }
}
